/* eslint-disable react/no-unused-prop-types */
import React from 'react';
export const TabItem = ({ children }) => (React.createElement("div", null, children));
//# sourceMappingURL=tab-item.js.map